<template>
  <div v-if="storeCatalog == 'WHI'">
    <div class="jstree jstree-1 jstree-default">
      <ul id="demo" class="jstree-container-ul jstree-children">
        <tree-item
          class="item"
          :item="treeData"
          @make-folder="makeFolder"
          @add-item="addItem"
          ></tree-item>
      </ul>
    </div>
  </div>
  <div v-else>
    <h6>Item Applications:</h6>
    <div class="">
      <table class="table">
        <thead>
          <tr>
            <th>Make</th>
            <th>Model</th>
            <th>Years</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, indx) in BUYG_res" :key="indx">
            <td>{{row.VMAKE}}</td>
            <td>{{row.VMODEL}}</td>
            <td>{{row.VY1 + '-' + row.VY2}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import axiosvl from "../../../axios/axios-vl.js";
  import TreeItem from './TreeItem';

  export default {
    components: {
      TreeItem
    },
    data() {
      return {
        static_treeData : {
          name: "Tree",
          children: [
            { name: "hello" },
            { name: "wat" },
            {
              name: "child folder",
              children: [
                {
                  name: "child folder",
                  children: [{ name: "hello" }, { name: "wat" }]
                },
                { name: "hello" },
                { name: "wat" },
                {
                  name: "child folder",
                  children: [{ name: "hello" }, { name: "wat" }]
                }
              ]
            }
          ]
        },
        storeCatalog: null,
        treeData : {
          name: "Item Applications: ",
          children: [

          ]
        },
        BUYG_res : [],
      }
    },
    props: {
      item_num: {
        type: String,
      },
      mfg_code : {
        type: String,
      }
    },
    methods: {
      makeFolder: function(item) {
        item.children = [];
        this.addItem(item);
      },
      addItem: function(item) {
        item.children.push({
          name: "new stuff"
        });
      },

      getTreeData(item_num = null){
        const buyers_uri = this.$store.getters['api/buyers_guide'];
        const catpn = this.$store.getters['storeConfigID'];
        // const catpn = (this.storeCatalog.toUpperCase() == 'WHI') ? '003' : '002';
        // QMFRCD/:QITEMC/:QTYPEC
        const QMFRCD = this.mfg_code;
        const QITEMC = (item_num) ? item_num : this.item_num;
        const QTYPEC = this.$route.params.QTYPEC;
        let params = '';
        if(this.storeCatalog == 'WHI'){
          params = {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {"value": this.$store.getters.customer},
                      "CATPN": {"value": catpn},
                      "QMFRCD": {"value": QMFRCD },
                      "QITEMC": {"value": QITEMC },
                      "QTYPEC": {"value": QTYPEC }
                  }
              }
          };
        }else{
          params = {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {"value": this.$store.getters.customer},
                      "CATPN": {"value": catpn},
                      "SRCITM": {"value": QITEMC }
                  }
              }
          };
        }
        
        axiosvl.post(buyers_uri, params)
        .then((response) => {
            
            if(this.storeCatalog == 'WHI'){
              this.whiResponseData(response);
            }else{
              this.partslinkResponseData(response);
            }

            this.isloading = false;
        })
        .catch((error) => {
            console.log("error - " + error);
            this.isloading = false;
        });
      },
      
      getTreeDataOld() {
        const buyers_uri = this.$store.getters['api/buyers_guide'];
        const catpn = this.$store.getters['storeConfigID'];
        // const catpn = (this.storeCatalog.toUpperCase() == 'WHI') ? '003' : '002';
        // QMFRCD/:QITEMC/:QTYPEC
        const QMFRCD = this.$route.params.QMFRCD;
        const QITEMC = this.$route.params.QITEMC;
        const QTYPEC = this.$route.params.QTYPEC;
        const params = {
            "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": {"value": this.$store.getters.customer},
                    "CATPN": {"value": catpn},
                    "QMFRCD": {"value": QMFRCD },
                    "QITEMC": {"value": QITEMC },
                    "QTYPEC": {"value": QTYPEC }
                }
            }
        };
        axiosvl.post(buyers_uri, params)
        .then((response) => {
            const fields = response.data.webroutine.fields
            let QMKDSC = '';
            let QMODSC = '';
            let lvl1 = 0;
            let lvl2 = 0;
            if (fields.RESULTCOD.value === 'OK') {
                for (const key in response.data.webroutine.lists.BUYG.entries) {
                    const obj = response.data.webroutine.lists.BUYG.entries[key];
                    // level 1 check if not added as children
                    if (QMKDSC != obj.QMKDSC) {
                      if(QMKDSC != ''){
                        lvl1 += 1;
                      }
                      
                      lvl2 = 0;
                      this.treeData.children.push({
                        name : obj.QMKDSC + ': ' + obj.QMKFY,
                        children: [],
                      });

                      QMODSC = '';
                      QMKDSC = obj.QMKDSC;
                    }else{
                      
                      // level 1 is already exists
                      // add items on level 2
                      if(QMODSC != obj.QMODSC){
                        this.treeData.children[lvl1].children.push({
                          name: obj.QMODSC + ': ' + obj.QMKFY,
                          children: []
                        });

                        if(QMODSC != ''){
                          lvl2 += 1;
                        }

                        QMODSC = obj.QMODSC
                        // skip after adding level 2
                        continue;
                      }

                      // add level 3
                      this.treeData.children[lvl1].children[lvl2].children.push({
                        name: obj.QENDSC + ': ' + obj.QMKFY,
                      });

                    }

                    this.BUYG_res.push({
                      BUYGL: obj.BUYGL,
                      QBSEQ: obj.QBSEQ,
                      QYEAR: obj.QYEAR,
                      QMAKE: obj.QMAKE,
                      QMKDSC: obj.QMKDSC,
                      QMODEL: obj.QMODEL,
                      QMODSC: obj.QMODSC,
                      QCARCD: obj.QCARCD,
                      QENDSC: obj.QENDSC,
                      QITPCQ: obj.QITPCQ,
                      QMKFY: obj.QMKFY,
                      QMKTY: obj.QMKTY,
                      QMOFY: obj.QMOFY,
                      QMOTY: obj.QMOTY,
                      QCMFRC: obj.QCMFRC,
                      QITEM: obj.QITEM,
                      QTYPE: obj.QTYPE,
                      QITDSC: obj.QITDSC,
                      QMFR: obj.QMFR,
                    });
                }
            }
            this.treeData.name += '(' + this.BUYG_res.length + ')';
            this.isloading = false;
        })
        .catch((error) => {
            console.error("error - " + error);
            this.isloading = false;
        });
      },

      whiResponseData(response){
        const fields = response.data.webroutine.fields
        let QMKDSC = '';
        let QMODSC = '';
        let lvl1 = 0;
        let lvl2 = 0;
        if (fields.RESULTCOD.value === 'OK') {
            for (const key in response.data.webroutine.lists.BUYG.entries) {
                const obj = response.data.webroutine.lists.BUYG.entries[key];
                // level 1 check if not added as children
                if (QMKDSC != obj.QMKDSC) {
                  if(QMKDSC != ''){
                    lvl1 += 1;
                  }
                  
                  lvl2 = 0;
                  this.treeData.children.push({
                    name : obj.QMKDSC + ': ' + obj.QMKFY,
                    children: [],
                  });

                  QMODSC = '';
                  QMKDSC = obj.QMKDSC;
                }else{
                  
                  // level 1 is already exists
                  // add items on level 2
                  if(QMODSC != obj.QMODSC){
                    this.treeData.children[lvl1].children.push({
                      name: obj.QMODSC + ': ' + obj.QMKFY,
                      children: []
                    });

                    if(QMODSC != ''){
                      lvl2 += 1;
                    }

                    QMODSC = obj.QMODSC
                    // skip after adding level 2
                    continue;
                  }

                  // add level 3
                  this.treeData.children[lvl1].children[lvl2].children.push({
                    name: obj.QENDSC + ': ' + obj.QMKFY,
                  });

                }

                this.BUYG_res.push({
                  BUYGL: obj.BUYGL,
                  QBSEQ: obj.QBSEQ,
                  QYEAR: obj.QYEAR,
                  QMAKE: obj.QMAKE,
                  QMKDSC: obj.QMKDSC,
                  QMODEL: obj.QMODEL,
                  QMODSC: obj.QMODSC,
                  QCARCD: obj.QCARCD,
                  QENDSC: obj.QENDSC,
                  QITPCQ: obj.QITPCQ,
                  QMKFY: obj.QMKFY,
                  QMKTY: obj.QMKTY,
                  QMOFY: obj.QMOFY,
                  QMOTY: obj.QMOTY,
                  QCMFRC: obj.QCMFRC,
                  QITEM: obj.QITEM,
                  QTYPE: obj.QTYPE,
                  QITDSC: obj.QITDSC,
                  QMFR: obj.QMFR,
                });
            }
        }
        this.treeData.name += '(' + this.BUYG_res.length + ')';
      },

      partslinkResponseData(response) {
        const fields = response.data.webroutine.fields
        const VEHICLES = response.data.webroutine.lists.VEHICLES;
        if (fields.RESULTCOD.value === 'OK') {
            for (const key in VEHICLES.entries) {
                const obj = VEHICLES.entries[key];
                this.BUYG_res.push(obj);
            }
        }
        console.table(this.BUYG_res);
        this.treeData.name += '(' + this.BUYG_res.length + ')';
      }

    },
    created() {
      this.storeCatalog = this.$store.getters['storeCatalog'];
      // console.log(this.storeCatalog);
      this.getTreeData();
    }
  }
</script>

<style scoped>
  ul {
    padding-left: 1em;
    line-height: 1.5em;
    list-style-type: none;
  }
</style>